import React from 'react';

function LinkIcon({ className }) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <rect width="30" height="30" fill="none"/>
            <path d="M15.7405 14.0595C15.2946 13.6137 14.6899 13.3633 14.0594 13.3633C13.4288 13.3633 12.8241 13.6137 12.3782 14.0595L10.6965 15.7406C10.2505 16.1866 10 16.7914 10 17.4221C10 18.0527 10.2505 18.6576 10.6965 19.1035C11.1424 19.5495 11.7473 19.8 12.3779 19.8C13.0086 19.8 13.6134 19.5495 14.0594 19.1035L14.8999 18.2629" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/>
            <path d="M14.0596 15.7405C14.5055 16.1863 15.1102 16.4367 15.7407 16.4367C16.3713 16.4367 16.976 16.1863 17.4219 15.7405L19.1036 14.0594C19.5496 13.6134 19.8001 13.0086 19.8001 12.3779C19.8001 11.7473 19.5496 11.1424 19.1036 10.6965C18.6577 10.2505 18.0528 10 17.4222 10C16.7915 10 16.1867 10.2505 15.7407 10.6965L14.9002 11.5371" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/>
        </svg>
    );
}

export default LinkIcon;
